// Tiny apps-api client. Talks to the same origin via /api/* (Caddy proxy strips
// the /api prefix and forwards to apps-api:9000).

import type { LeaderboardEntry } from "./state";

let cachedJwt: string | null = null;

function apiBase(): string {
  // In dev, Vite may serve at :5173 — point /api to the deployed apps-api via env override.
  return (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api";
}

export async function authenticate(initData: string): Promise<string> {
  const res = await fetch(`${apiBase()}/auth`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ init_data: initData }),
  });
  if (!res.ok) {
    throw new Error(`/auth failed: ${res.status}`);
  }
  const data = (await res.json()) as { jwt: string };
  cachedJwt = data.jwt;
  return data.jwt;
}

function authHeaders(): HeadersInit {
  if (!cachedJwt) {
    return { "Content-Type": "application/json" };
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cachedJwt}`,
  };
}

export async function submitScore(timeMs: number, carId: string): Promise<void> {
  const res = await fetch(`${apiBase()}/racing/submit`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ time_ms: timeMs, car_id: carId }),
  });
  if (!res.ok) {
    throw new Error(`/racing/submit failed: ${res.status}`);
  }
}

export async function fetchLeaderboard(): Promise<LeaderboardEntry[]> {
  const res = await fetch(`${apiBase()}/racing/leaderboard`, {
    headers: authHeaders(),
  });
  if (!res.ok) {
    throw new Error(`/racing/leaderboard failed: ${res.status}`);
  }
  const data = (await res.json()) as { entries: LeaderboardEntry[] };
  return data.entries;
}

export function setJwt(jwt: string): void {
  cachedJwt = jwt;
}

export function hasJwt(): boolean {
  return cachedJwt !== null;
}
